import React from 'react';
import ReactDom from 'react-dom';

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {deepBind} from 'base-contentmodel';

import BaseComponent from 'base-component';
import BaseContentModel from 'base-contentmodel';

import {ContentModel as ExampleActivityContentModel} from 'trc-example-activity';

import DefaultShellComponent from './component';

export class DefaultShellSubContentModel extends BaseContentModel{
  static _slots = {
    text: "",    
    richText: "RichText"
  }
  /* @slot */ @observable 
  text = "Default text"

  /* @slot("RichText") */ @observable 
  richText = "Default text for richText"  
}

export class DefaultShellContentModel extends BaseContentModel{
  // the ContentModel classes contain the customizable "slots" that content creators will be filling in
  // presently these are defined via static _slots, but will be applied via @slot sugar
  // see the list below for examples of the slot types, and the editor input created for each:
  static _slots = {
    logo: "",    
    header: "", // textarea
    body: "RichText", // trix wysiwyg
    textOptionsSlot: "", // see _options,
    ref: ExampleActivityContentModel  
  }
  // options are a way to supply slots with specific options
  // this is currently defined manually, but will be taken care of by @options decorator 
  @observable @deepBind _options = {
    get textOptionsSlot(){ // turns textOptionsSlot into dropdown
      return ["Option1", "Option2", "Option3"];
    }
  }
  // define the default Component (Sim) view of this component
  Component = DefaultShellComponent

  // below is what content model definitions will ultimately look like. note the commented out decorators.
  // when these are in place, you will not need @observable, @observable.ref, etc

  @observable 
  /* @slot */ logo = "assets/images/trc-logo-inverted.svg"

  @observable 
  /* @slot */ header = ""

  @observable 
  /* @slot("RichText") */ body = ""

  @observable 
  /* @options(["Option1", "Option2", "Option3"]) @slot */ textOptionsSlot = ""

  @observable.ref 
  /* @slot("ExampleActivityContentModel") */ ref = null

}
export default DefaultShellContentModel


// WEBPACK FOOTER //
// ./app_modules/default-simulation-shell/contentmodel.js